<template>
  <div class="this-page" id="position">
    <div class="content" v-if="netError">
      <p style="color: red">网络请求超时，请刷新页面重试</p>
    </div>
    <el-alert
      v-if="anyLoading"
      class="wait-alert"
      type="error"
      :closable="false"
      show-icon
      title="等待模式处理中：已扣费，素材正在后台生成下载链接"
      description="通常需 20 秒 - 2 分钟，完成后会自动出现下载按钮，无需刷新页面；若下载失败，费用将自动退回，请重新尝试或联系上方微信客服。请耐心等待，不要关闭页面。"
      style="margin-bottom: 15px"
    >
    </el-alert>
    <el-table
      :data="tableData"
      class="table"
      id="position"
      v-if="!downloadStarted"
      key="pre-download"
    >
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column label="照片信息">
        <template slot-scope="scope">
          <!-- <img :src="scope.row.img" alt /> -->
          <el-image
            v-show="
              scope.row.webType !== 'shutterstock_V2' &&
              scope.row.webType !== 'music' &&
              scope.row.webType !== 'shutterstock_V3'
            "
            style="
              margin-right: 10px;
              float: left;
              width: 60px;
              height: 60px;
              border-radius: 4px;
              cursor: pointer;
            "
            :src="scope.row.img"
            @click="handleImgPreview(scope.row)"
          >
            <div slot="error" class="image-slot">
              <img
                :src="scope.row.errorIcon"
                @click="handleImgPreview(scope.row)"
                alt
              />
            </div>
          </el-image>
          <div class="fr">
            <p class="code">{{ scope.row.id }}</p>
            <p class="label" v-if="scope.row.webType == 'music'">
              音乐名:{{ scope.row.title }} &nbsp; 作者:{{ scope.row.videoSize }}
            </p>
            <p class="label" v-else>
              {{ scope.row.imgType }}
              <span class="size">{{ scope.row.imgSize }}</span>
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="下载费用">
        <template slot-scope="scope">
          <div class="price" v-if="scope.row.complete">
            <p class="font-red">余额：{{ scope.row.price }}元</p>
          </div>
          <div class="price" v-else>
            <p
              class="font-blue"
              v-if="scope.row.type && !scope.row.isBuy && !scope.row.isChange"
            >
              单价：{{ scope.row.price }} 元
              <span v-if="scope.row.orgPrice"
                ><del>(原价：{{ scope.row.orgPrice }} 元)</del></span
              >
              <br />
              <span v-show="scope.row.isOffset" class="font-red"
                >（此图为高级图，请确认费用后联系客服下载）</span
              >
            </p>
            <p
              class="font-blue"
              v-else-if="
                scope.row.type && !scope.row.isBuy1 && scope.row.isChange
              "
            >
              单价：{{ scope.row.price }} 元
              <span v-if="scope.row.orgPrice"
                ><del>(原价：{{ scope.row.orgPrice }} 元)</del></span
              >
            </p>
            <p class="font-blue" v-else>{{ scope.row.msg }}</p>
            <el-button
              type="danger"
              round
              v-if="scope.row.saleType !== null && scope.row.saleType !== ''"
              size="mini"
              >{{ scope.row.saleType }}</el-button
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column label="图片格式">
        <template slot-scope="scope" v-if="scope.row.showType">
          <div v-if="!scope.row.isVideo">
            <el-select
              v-model="scope.row.value"
              v-if="scope.row.type"
              :disabled="scope.row.disabled"
              placeholder="请选择"
            >
              <el-option
                v-for="item in scope.row.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <!-- {{scope.row.options[0].label}} -->
          </div>
          <div v-else-if="scope.row.webType == 'vadobestock'">
            <span class="font-red">HD/4K(官网最大像素)</span>
          </div>
          <div v-else-if="scope.row.webType == 'music'">
            <span class="font-red">wav全曲</span>
          </div>
          <div v-else>
            <el-radio-group
              v-model="scope.row.videoLabel"
              v-if="scope.row.type"
              :disabled="scope.row.videoDisabled"
            >
              <el-radio
                v-for="item in scope.row.videoOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                @change="
                  changePrice(scope.$index, tableData, item.label, item.value)
                "
              ></el-radio>
            </el-radio-group>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作状态">
        <template slot-scope="scope">
          <div class="processBar" v-if="scope.row.loading"></div>
          <div v-else-if="!scope.row.loading && scope.row.complete">
            <div v-if="scope.row.webType !== 'music'">
              <a rel="nofollow" :href="scope.row.downurl" target="_blank"
                ><el-button
                  type="primary"
                  size="small"
                  style="margin-left: 5px; margin-top: 5px"
                  >点击下载</el-button
                ></a
              >
              <a
                v-if="scope.row.downurl2"
                rel="nofollow"
                :href="scope.row.downurl2"
                target="_blank"
                ><el-button
                  type="success"
                  size="small"
                  style="margin-left: 5px; margin-top: 5px"
                  >备用下载</el-button
                ></a
              >
              <a
                v-if="scope.row.downurl3"
                rel="nofollow"
                :href="scope.row.downurl3"
                target="_blank"
                ><el-button
                  type="danger"
                  size="small"
                  style="margin-left: 5px; margin-top: 5px"
                  >海外下载</el-button
                ></a
              >
            </div>
            <div v-else>
              <a rel="nofollow" :href="scope.row.downurl" target="_blank"
                ><el-button
                  type="primary"
                  size="small"
                  style="margin-left: 5px; margin-top: 5px"
                  >全曲版本</el-button
                ></a
              >
              <a
                v-if="scope.row.downurl2"
                rel="nofollow"
                :href="scope.row.downurl2"
                target="_blank"
                ><el-button
                  type="success"
                  size="small"
                  style="margin-left: 5px; margin-top: 5px"
                  >海外下载</el-button
                ></a
              >
              <a
                v-if="scope.row.downurl3"
                rel="nofollow"
                :href="scope.row.downurl3"
                target="_blank"
                ><el-button
                  type="danger"
                  size="small"
                  style="margin-left: 5px; margin-top: 5px"
                  >分段版本</el-button
                ></a
              >
              <a
                v-if="scope.row.downurl4"
                rel="nofollow"
                :href="scope.row.downurl4"
                target="_blank"
                ><el-button
                  type="info"
                  size="small"
                  style="margin-left: 5px; margin-top: 5px"
                  >海外下载</el-button
                ></a
              >
            </div>
          </div>
          <div v-else-if="scope.row.waitState === 'unconfirmed'">
            <p>{{ scope.row.msg }}</p>
            <el-button
              v-if="scope.row.waitPrecheckFailed"
              type="primary"
              size="small"
              @click="retryWaitPrecheck(scope.$index)"
              >重新检查余额</el-button
            >
            <el-button
              v-else
              type="primary"
              size="small"
              @click="resumeWaitDownload(scope.$index)"
              >查询状态</el-button
            >
          </div>
          <div v-else-if="!scope.row.loading && scope.row.error">
            <p style="color: red">{{ scope.row.msg }}</p>
            <el-button
              v-if="scope.row.waitPrecheckFailed"
              type="primary"
              size="small"
              @click="retryWaitPrecheck(scope.$index)"
              >重新检查余额</el-button
            >
            <div v-if="hasFallbackFailure(scope.row)" class="fallback-options">
              <template v-if="!['manualSubmitted', 'manualUnknown'].includes(scope.row.fallbackState)">
                <el-button type="primary" size="small"
                  :disabled="!canChooseFallback(scope.row)" @click="chooseManualDownload(scope.$index)">
                  人工下载 ¥4
                </el-button>
                <el-button type="danger" size="small"
                  :disabled="!canChooseFallback(scope.row) || !v4Available()" @click="changeV4(scope.$index)">
                  {{ v4Available() ? 'V4 下载 ¥6' : 'V4 维护中' }}
                </el-button>
              </template>
              <router-link v-else to="/workOrderDown">查看人工工单</router-link>
            </div>
          </div>
          <div v-else>
            <el-button v-if="single" type="primary" size="small" :disabled="!scope.row.type"
              @click="downloadOne(scope.$index)">确认下载</el-button>
            <el-button
              v-else
              type="text"
              size="middle"
              @click="deleteRow(scope.$index, tableData)"
              ><i class="el-icon-close"></i
            ></el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-table
      :data="tableData"
      class="table"
      v-else
      key="download-status"
    >
      <el-table-column type="index" width="60" label="序号"></el-table-column>
      <el-table-column label="素材ID" min-width="200">
        <template slot-scope="scope">
          <span class="id-tag">{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="价格" width="130">
        <template slot-scope="scope">
          <div class="price" v-if="scope.row.complete">
            <p class="font-red">余额：{{ scope.row.price }} 元</p>
          </div>
          <div class="price" v-else>
            <p
              class="font-blue"
              v-if="scope.row.type && !scope.row.isBuy && !scope.row.isChange"
            >
              单价：{{ scope.row.price }} 元
              <span v-if="scope.row.orgPrice"
                ><del>(原价：{{ scope.row.orgPrice }} 元)</del></span
              >
            </p>
            <p
              class="font-blue"
              v-else-if="
                scope.row.type && !scope.row.isBuy1 && scope.row.isChange
              "
            >
              单价：{{ scope.row.price }} 元
              <span v-if="scope.row.orgPrice"
                ><del>(原价：{{ scope.row.orgPrice }} 元)</del></span
              >
            </p>
            <p class="font-blue" v-else>{{ scope.row.msg }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="170">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.loading"
            type="warning"
            size="small"
            effect="plain"
            >下载中</el-tag
          >
          <el-tag
            v-else-if="scope.row.complete"
            type="success"
            size="small"
            effect="plain"
            >已完成</el-tag
          >
          <el-tag
            v-else-if="scope.row.error"
            type="danger"
            size="small"
            effect="plain"
            >失败</el-tag
          >
          <el-tag
            v-else-if="scope.row.type"
            type="info"
            size="small"
            effect="plain"
            >等待处理</el-tag
          >
          <el-tag v-else type="info" size="small" effect="plain"
            >获取失败</el-tag
          >
          <div v-if="scope.row.loading" class="wait-time">
            <i class="el-icon-time"></i>
            <span>已扣费，下载中，失败自动退回</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="提交时间" width="180">
        <template slot-scope="scope">
          <span class="time">{{ scope.row.submitTime || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="240">
        <template slot-scope="scope">
          <div v-if="scope.row.complete">
            <div v-if="scope.row.webType !== 'music'">
              <a rel="nofollow" :href="scope.row.downurl" target="_blank"
                ><el-button type="primary" size="small">点击下载</el-button></a
              >
              <a
                rel="nofollow"
                :href="scope.row.downurl2"
                target="_blank"
                style="margin-left: 5px"
                ><el-button type="success" size="small">备用下载</el-button></a
              >
              <a
                rel="nofollow"
                :href="scope.row.downurl3"
                target="_blank"
                style="margin-left: 5px"
                ><el-button type="danger" size="small">海外下载</el-button></a
              >
            </div>
            <div v-else>
              <a rel="nofollow" :href="scope.row.downurl" target="_blank"
                ><el-button type="primary" size="small">全曲版本</el-button></a
              >
              <a
                rel="nofollow"
                :href="scope.row.downurl2"
                target="_blank"
                style="margin-left: 5px"
                ><el-button type="success" size="small">海外下载</el-button></a
              >
              <a
                rel="nofollow"
                :href="scope.row.downurl3"
                target="_blank"
                style="margin-left: 5px"
                ><el-button type="danger" size="small">分段版本</el-button></a
              >
              <a
                rel="nofollow"
                :href="scope.row.downurl4"
                target="_blank"
                style="margin-left: 5px"
                ><el-button type="info" size="small">海外下载</el-button></a
              >
            </div>
          </div>
          <div v-else-if="scope.row.loading">
            <el-button type="text" size="small" :loading="true"
              >下载中…</el-button
            >
            <el-tag
              type="info"
              size="small"
              effect="plain"
              style="margin-left: 5px"
              >等待模式</el-tag
            >
          </div>
          <div v-else-if="scope.row.waitState === 'unconfirmed'">
            <p>{{ scope.row.msg }}</p>
            <el-button
              v-if="scope.row.waitPrecheckFailed"
              type="primary"
              size="small"
              @click="retryWaitPrecheck(scope.$index)"
              >重新检查余额</el-button
            >
            <el-button
              v-else
              type="primary"
              size="small"
              @click="resumeWaitDownload(scope.$index)"
              >查询状态</el-button
            >
          </div>
          <div v-else-if="scope.row.error">
            <p style="color: red">{{ scope.row.msg }}</p>
            <el-button
              v-if="scope.row.waitPrecheckFailed"
              type="primary"
              size="small"
              @click="retryWaitPrecheck(scope.$index)"
              >重新检查余额</el-button
            >
            <div v-if="hasFallbackFailure(scope.row)" class="fallback-options">
              <template v-if="!['manualSubmitted', 'manualUnknown'].includes(scope.row.fallbackState)">
                <el-button type="primary" size="small"
                  :disabled="!canChooseFallback(scope.row)" @click="chooseManualDownload(scope.$index)">
                  人工下载 ¥4
                </el-button>
                <el-button type="danger" size="small"
                  :disabled="!canChooseFallback(scope.row) || !v4Available()" @click="changeV4(scope.$index)">
                  {{ v4Available() ? 'V4 下载 ¥6' : 'V4 维护中' }}
                </el-button>
              </template>
              <router-link v-else to="/workOrderDown">查看人工工单</router-link>
            </div>
          </div>
          <div v-else>
            <el-button
              type="text"
              size="small"
              @click="deleteRow(scope.$index, tableData)"
              ><i class="el-icon-close"></i> 移除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      :pager-count="11"
      layout="total, sizes, prev, pager, next"
      :total="tableData.length"
      v-if="tableData.length > 100"
    ></el-pagination>
    <div class="btn" v-if="!sureflag">
      <el-button
        type="primary"
        @click="sureDownload"
        icon="el-icon-download"
        :disabled="downflag"
        >确认下载</el-button
      >
    </div>
    <div class="btn2" v-else>
      <div v-if="tableData[0].webType !== 'music'">
        <div class="el-row">
          <el-button
            type="primary"
            @mousedown.native="batchDownload"
            plain
            icon="el-icon-download"
            >批量下载</el-button
          >
          <el-button
            type="primary"
            @mousedown.native="batchCopy($event)"
            plain
            icon="el-icon-edit-outline"
            style="margin-left: 1%"
            >一键复制下载链接</el-button
          >
        </div>
        <div class="el-row">
          <el-button
            type="primary"
            @mousedown.native="batchDownload1"
            plain
            icon="el-icon-download"
            >批量备用下载</el-button
          >
          <el-button
            type="primary"
            @mousedown.native="batchCopy1($event)"
            plain
            icon="el-icon-edit-outline"
            style="margin-left: 1%"
            >一键复制备用下载链接</el-button
          >
        </div>
        <div class="el-row">
          <el-button
            type="primary"
            @mousedown.native="batchDownload2"
            plain
            icon="el-icon-download"
            >批量海外下载</el-button
          >
          <el-button
            type="primary"
            @mousedown.native="batchCopy2($event)"
            plain
            icon="el-icon-edit-outline"
            style="margin-left: 1%"
            >一键复制海外下载链接</el-button
          >
        </div>
      </div>
      <div v-else>
        <div class="el-row">
          <el-button
            type="primary"
            @mousedown.native="batchDownload()"
            plain
            icon="el-icon-download"
            >批量全曲下载</el-button
          >
          <el-button
            type="primary"
            @mousedown.native="batchCopy($event)"
            plain
            icon="el-icon-edit-outline"
            style="margin-left: 1%"
            >一键复制全曲下载链接</el-button
          >
        </div>
        <div class="el-row">
          <el-button
            type="primary"
            @mousedown.native="batchDownload1()"
            plain
            icon="el-icon-download"
            >批量全曲海外下载</el-button
          >
          <el-button
            type="primary"
            @mousedown.native="batchCopy1($event)"
            plain
            icon="el-icon-edit-outline"
            style="margin-left: 1%"
            >一键复制全曲海外下载链接</el-button
          >
        </div>
        <div class="el-row">
          <el-button
            type="primary"
            @mousedown.native="batchDownload2()"
            plain
            icon="el-icon-download"
            >批量分段下载</el-button
          >
          <el-button
            type="primary"
            @mousedown.native="batchCopy2($event)"
            plain
            icon="el-icon-edit-outline"
            style="margin-left: 1%"
            >一键复制分段下载链接</el-button
          >
        </div>
        <div class="el-row">
          <el-button
            type="primary"
            @mousedown.native="batchDownload3()"
            plain
            icon="el-icon-download"
            >批量分段海外下载</el-button
          >
          <el-button
            type="primary"
            @mousedown.native="batchCopy3($event)"
            plain
            icon="el-icon-edit-outline"
            style="margin-left: 1%"
            >一键复制分段海外下载链接</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="imgPreviewVisible" center :show-close="false">
      <template #title>
        <DialogCloseBtn @close="imgPreviewVisible = false" />
        图片预览
      </template>
      <div
        style="
          width: 100%;
          text-align: center;
          max-height: 450px;
          overflow: auto;
        "
      >
        <el-image :src="currentImg">
          <div slot="error" class="image-slot">
            <img
              :src="currentError"
              style="object-fit: fill; width: 100%; height: 107.5%"
              alt
            />
          </div>
        </el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { hasBlance, searchImage } from "../../../api/downLoad";
import { quoteWorkOrderFallback, submitWorkOrder } from "../../../api/workOrder";
import { buyWait, check } from "../../../api/downLoad";
import { createWaitDownloadFlow } from "../../../api/waitDownload";
import { getSessionUser } from "../../../api/auth";
import { message } from "@/utils/resetMessage";
import { MessageBox } from "element-ui";
import Clipboard from "clipboard";
import DialogCloseBtn from "@/components/DialogCloseBtn.vue";
import { getToken, getV4Status } from "../../../utils/storage";
import { downloadFile as safeDownloadFile } from "@/utils/download";
export const downloadFile = safeDownloadFile;

export default {
  components: {
    DialogCloseBtn,
  },
  props: ["data", "sureflag", "downflag", "clearflag", "netError", "single"],
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      downloadStarted: false,
      urlArray: [], //批量下载
      urlArray1: [], //批量备用下载
      urlArray2: [], //批量海外下载
      urlArray3: [], //批量海外下载  分段海外下载
      currentIndex: 0, //当前列表序号
      isAutoDowload: false, //是否自动下载
      imgPreviewVisible: false,
      currentError: "",
      currentImg: "",
    };
  },
  watch: {
    clearflag: {
      handler(val) {
        if (val) {
          this.cancelWaitDownloads();
          this.currentIndex = 0;
          this.downloadStarted = false;
        }
      },
      deep: true,
    },
    data(rows) {
      this._waitRecords.forEach((record, row) => {
        if (!rows.includes(row)) this.cancelWaitRecord(record);
      });
      const batch = this._waitBatch;
      if (batch && !batch.rows.some((row) => rows.includes(row))) {
        this._waitBatch = null;
        this.downloadStarted = false;
        this.$emit("onSureDown", false);
        this.$emit("onDownload", false);
      } else if (batch && !rows.includes(batch.rows[batch.index])) {
        this.continueWaitBatch(batch);
      }
    },
  },
  computed: {
    tableData() {
      return this.data;
    },
    anyLoading() {
      return this.tableData.some((r) => r.loading);
    },
  },
  created() {
    this._waitRecords = new Map();
    this._fallbackChoices = new Map();
    this._waitEpoch = 0;
    this._waitDisposed = false;
    this._waitOwner = {};
    this._waitBatchId = 0;
    this._waitBatch = null;
    this._waitConfirmPending = false;
    this._waitFlow = createWaitDownloadFlow({
      submit: buyWait,
      check,
      getSession: getToken,
    });
    this._waitClearHandler = () => this.cancelWaitDownloads();
    this.$on("clearTimer", this._waitClearHandler);
  },
  mounted() {
    this._waitMoveHandler = (data) => {
      if (data == "1" && !this.isSearchPreview) {
        this.goAnchor("position");
      }
    };
    this._waitAutoHandler = (data) => {
      if (data == "1" && !this.isSearchPreview) {
        this.sureDownload();
      }
    };
    this._waitNextIdHandler = (event) => {
      const batch = this._waitBatch;
      if (
        !event ||
        event.owner !== this._waitOwner ||
        !batch ||
        event.batchId !== batch.id ||
        event.row !== batch.rows[batch.index]
      )
        return;
      batch.index++;
      this.continueWaitBatch(batch);
    };
    this.$EventBus.$on("move", this._waitMoveHandler);
    this.$EventBus.$on("auto", this._waitAutoHandler);
    this.$EventBus.$on("nextId", this._waitNextIdHandler);
  },
  beforeDestroy() {
    this._waitDisposed = true;
    this.cancelWaitDownloads();
    this._waitFlow.dispose();
    this.$off("clearTimer", this._waitClearHandler);
    this.$EventBus.$off("move", this._waitMoveHandler);
    this.$EventBus.$off("auto", this._waitAutoHandler);
    this.$EventBus.$off("nextId", this._waitNextIdHandler);
  },
  methods: {
    waitRecordIsCurrent(record) {
      return (
        !this._waitDisposed &&
        record.active &&
        record.epoch === this._waitEpoch &&
        record.session === getToken() &&
        this._waitRecords.get(record.row) === record &&
        record.params.imageID === record.row.id &&
        this.tableData.includes(record.row)
      );
    },
    cancelWaitRecord(record) {
      if (!record.active) return;
      const choice = this._fallbackChoices.get(record.session + "#" + record.row.id);
      if (choice && choice.record === record) {
        if (["quoting", "confirming"].includes(choice.state)) this.setFallbackState(record.row, "", record);
        else if (choice.state === "manualSubmitting") this.setFallbackState(record.row, "manualUnknown", record);
      }
      record.active = false;
      if (record.handle) record.handle.cancel();
    },
    cancelWaitDownloads() {
      this._waitEpoch++;
      this._waitConfirmPending = false;
      this._waitRecords.forEach((record) => this.cancelWaitRecord(record));
      this._waitRecords.clear();
      this._waitFlow.cancelAll();
      this._waitBatch = null;
    },
    waitCallbacks(record) {
      return {
        onState: (update) => {
          if (this.waitRecordIsCurrent(record))
            this.applyWaitState(record, update);
          else this.cancelWaitRecord(record);
        },
        onSettled: () => {
          if (!this.waitRecordIsCurrent(record)) return;
          getSessionUser({})
            .then((result) => {
              if (this.waitRecordIsCurrent(record))
                this.$store.dispatch("setUserInfo", result);
            })
            .catch(() => {});
          this.advanceWaitBatch(record.row, record.batch);
        },
      };
    },
    applyWaitState(record, update) {
      const row = record.row;
      if (update.params) record.params = { ...update.params };
      const data = update.data || {};
      const state =
        update.state === "success" &&
        (typeof data.downloadUrl !== "string" || !data.downloadUrl.trim())
          ? "unconfirmed"
          : update.state;
      record.state = state;
      this.$set(row, "waitState", state);
      this.$set(row, "waitParams", { ...record.params });
      this.$set(row, "waitSession", record.session);
      this.$set(row, "waitPurchaseStarted", Boolean(record.purchaseStarted));
      this.$set(row, "submitted", Boolean(record.purchaseStarted));
      this.$set(row, "fallbackState", this.fallbackState(row));
      this.$set(
        row,
        "waitPrecheckFailed",
        Boolean(record.precheckFailed && !record.purchaseStarted)
      );
      this.$set(row, "checking", true);
      row.loading = state === "submitting" || state === "pending";
      row.complete = state === "success";
      row.error = state === "failed";
      row.msg =
        state === "unconfirmed"
          ? row.waitPrecheckFailed
            ? "余额检查未完成，尚未提交下载，请重新检查余额"
            : "状态未确认，请查看下载记录，勿重复提交"
          : update.message || "";
      const lockFormat = state !== "failed" && !row.waitPrecheckFailed;
      this.$set(row, "disabled", lockFormat || record.initialDisabled);
      this.$set(
        row,
        "videoDisabled",
        lockFormat || record.initialVideoDisabled
      );
      if (record.purchaseStarted) {
        row.value = record.params.format;
        row.isCos = record.params.isCos;
        if (record.initialVideoValue !== undefined)
          row.videoValue = record.initialVideoValue;
        if (record.initialVideoLabel !== undefined)
          row.videoLabel = record.initialVideoLabel;
      }
      row.showButton = false;
      row.showButton2 =
        state === "failed" &&
        !record.precheckFailed &&
        record.params.webType !== "shutterstock_V4" &&
        ["shutterstock", "shutterstock_V2", "shutterstock_V3"].includes(
          record.params.webType
        ) &&
        getV4Status() === "online";
      if (state === "success") {
        row.videoDisabled = true;
        row.disabled = true;
        const url = (value) =>
          typeof value === "string"
            ? value
                .trim()
                .replace("httpss", "https")
                .replace("down.songzituku.com", "pp.sucaidaixia.com")
            : "";
        row.downurl = url(data.downloadUrl);
        row.downurl2 = url(data.downloadUrl2);
        row.downurl3 = url(data.downloadUrl3);
        row.downurl4 = url(data.downloadUrl4);
        row.price = data.price;
        ["downurl", "downurl2", "downurl3", "downurl4"].forEach(
          (key, index) => {
            const list = [
              this.urlArray,
              this.urlArray1,
              this.urlArray2,
              this.urlArray3,
            ][index];
            if (row[key] && !list.includes(row[key])) list.push(row[key]);
          }
        );
      }
    },
    popSuccess() {
      if (document.getElementsByClassName("el-message").length > 0) return;
      this.$message({
        message: "下载成功",
        type: "success",
        showClose: true,
        duration: 4000,
        offset: 80,
      });
    },
    goAnchor(e) {
      var id = "#" + e;
      document.querySelector(id).scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    },
    formattedMsg(msg) { return String(msg || "").replace(/\n/g, "<br>"); },
    //普通下载
    ordinaryDownload(index, row) {
      //window.open(row.downurl,"_self");
      downloadFile(row.downurl);
    },
    //备用下载
    standbyDownload(index, row) {
      //window.open(row.downurl2,"_self");
      downloadFile(row.downurl2);
    },
    //迅雷下载
    thunderDownload(index, row) {
      console.log("thunderDownload: " + row.downurl);
      //this.thunderHref=row.downurl;
      console.log("thunderDownload: " + index);
    },
    fallbackState(row) {
      const choice = this._fallbackChoices.get(getToken() + "#" + row.id);
      return choice ? choice.state : "";
    },
    setFallbackState(row, state, record = this._waitRecords.get(row)) {
      const key = (record ? record.session : getToken()) + "#" + row.id;
      if (state) this._fallbackChoices.set(key, { state, record });
      else this._fallbackChoices.delete(key);
      this.$set(row, "fallbackState", state);
    },
    hasFallbackFailure(row) {
      const record = this._waitRecords.get(row);
      return Boolean(record && this.waitRecordIsCurrent(record) &&
        record.state === "failed" && record.purchaseStarted &&
        !record.precheckFailed && !row.isOffset &&
        ["shutterstock", "shutterstock_V2", "shutterstock_V3"].includes(record.params.webType));
    },
    canChooseFallback(row) {
      return this.hasFallbackFailure(row) && !this.fallbackState(row);
    },
    v4Available() {
      return getV4Status() === "online";
    },
    async chooseFallback(index, channel) {
      const row = this.tableData[index];
      if (!this.canChooseFallback(row) || (channel === "v4" && !this.v4Available())) return;
      const record = this._waitRecords.get(row);
      const current = () => this.waitRecordIsCurrent(record) && record.session === getToken();
      this.setFallbackState(row, "quoting");
      let submitted = false;
      try {
        if (channel === "manual") {
          const quote = await quoteWorkOrderFallback({ imageID: row.id, sourceWebType: record.params.webType });
          if (!current()) return;
          if (!quote || Number(quote.price) !== 4) throw new Error("人工下载报价未确认，请稍后重试");
          this.setFallbackState(row, "confirming");
          await MessageBox.confirm(
            "素材 " + row.id + "：人工下载 ¥4。确认后提交工单并扣费，等待处理；下载失败按工单规则退款。",
            "确认人工下载", { confirmButtonText: "确认提交 ¥4", cancelButtonText: "取消", type: "warning" }
          );
          if (!current()) return;
          this.setFallbackState(row, "manualSubmitting");
          submitted = true;
          const result = await submitWorkOrder({ materialIds: [row.id], webType: "shutterstock", fallbackFromV1: true, sourceWebType: record.params.webType, expectedPrice: 4 });
          if (!current()) return;
          const order = result && Array.isArray(result.orders) && result.orders[0];
          if (!order || !order.workOrderId) throw new Error("工单提交结果未确认");
          this.$set(row, "manualWorkOrderId", order.workOrderId);
          this.setFallbackState(row, "manualSubmitted");
          row.msg = "人工工单已提交，请在人工下载记录中查看进度";
          getSessionUser({}).then(user => {
            if (current()) this.$store.dispatch("setUserInfo", user);
          }).catch(() => {});
        } else {
          const quote = await searchImage({ imageID: row.id, webType: "shutterstock_V4" });
          if (!current()) return;
          const quotedPrice = Number(quote && quote.price);
          if (!quote || quote.status != 0 || String(quote.recCode) !== String(row.id) ||
              !["number", "string"].includes(typeof quote.price) || !Number.isFinite(quotedPrice) || quotedPrice <= 0 || quotedPrice > 6)
            throw new Error("V4 下载报价未确认或已变化，请重新查询");
          if (quotedPrice !== 6) {
            this.setFallbackState(row, "confirming");
            await MessageBox.confirm(
              "素材 " + row.id + "：当前账户 V4 下载报价为 ¥" + quotedPrice + "，确认后提交下载。",
              "确认 V4 下载", { confirmButtonText: "确认下载 ¥" + quotedPrice, cancelButtonText: "取消", type: "warning" }
            );
            if (!current()) return;
          }
          if (!this.v4Available()) throw new Error("V4 暂时维护中，请选择人工下载");
          this.setFallbackState(row, "v4Submitted");
          row.price = quotedPrice;
          row.isBuy = false;
          this.startRowDownload(index, "shutterstock_V4");
        }
      } catch (error) {
        if (!current()) return;
        if (submitted) {
          this.setFallbackState(row, "manualUnknown");
          row.msg = "工单提交状态未确认，请查看人工下载记录，勿重复提交";
        } else {
          this.setFallbackState(row, "");
          if (error !== "cancel" && error !== "close") {
            row.msg = (error && (error.message || error.msg)) || String(error);
            message.error({ message: row.msg, offset: 80 });
          }
        }
      }
    },
    chooseManualDownload(index) {
      return this.chooseFallback(index, "manual");
    },
    changeV4(index) {
      return this.chooseFallback(index, "v4");
    },
    stampSubmitTime() {
      const now = this.nowStr();
      this.tableData.forEach((item) => {
        if (item.type && !item.submitTime) {
          this.$set(item, "submitTime", now);
        }
      });
    },
    nowStr() {
      const d = new Date();
      const p = (n) => String(n).padStart(2, "0");
      return (
        d.getFullYear() +
        "-" +
        p(d.getMonth() + 1) +
        "-" +
        p(d.getDate()) +
        " " +
        p(d.getHours()) +
        ":" +
        p(d.getMinutes()) +
        ":" +
        p(d.getSeconds())
      );
    },
    //确认下载：同一批次仅推进一次；再次操作已提交行只恢复查询。
    sureDownload() {
      if (this._waitDisposed || this._waitConfirmPending || this._waitBatch)
        return;
      const rows = this.tableData.filter((row) => row.type && !row.complete);
      if (!rows.length) return;
      const epoch = this._waitEpoch;
      const session = getToken();
      this._waitConfirmPending = true;
      const begin = () => {
        if (
          this._waitDisposed ||
          epoch !== this._waitEpoch ||
          session !== getToken()
        )
          return;
        this._waitConfirmPending = false;
        const activeRows = rows.filter((row) => this.tableData.includes(row));
        if (!activeRows.length) return;
        this.downloadStarted = true;
        this.stampSubmitTime();
        this.$emit("onSureDown", false);
        this.$emit("onDownload", true);
        const batch = {
          id: ++this._waitBatchId,
          rows: activeRows,
          index: 0,
          advanced: new Set(),
          epoch,
          session,
        };
        this._waitBatch = batch;
        this.continueWaitBatch(batch);
      };
      if (rows.some((row) => row.isOffset)) {
        MessageBox.confirm(
          "您此次下载含ss高级图，高级图费用较特殊，请您确认是否下载？",
          "温馨提示",
          {
            confirmButtonText: "继续下载",
            cancelButtonText: "取消下载",
            type: "warning",
          }
        )
          .then(begin)
          .catch(() => {
            if (epoch === this._waitEpoch) this._waitConfirmPending = false;
          });
      } else begin();
    },
    continueWaitBatch(batch) {
      if (
        this._waitDisposed ||
        this._waitBatch !== batch ||
        batch.epoch !== this._waitEpoch ||
        batch.session !== getToken()
      )
        return;
      while (
        batch.index < batch.rows.length &&
        !this.tableData.includes(batch.rows[batch.index])
      )
        batch.index++;
      if (batch.index >= batch.rows.length) {
        this._waitBatch = null;
        this.$emit("onSureDown", true);
        this.$emit("onDownload", false);
        return;
      }
      const row = batch.rows[batch.index];
      this.currentIndex = this.tableData.indexOf(row);
      const record = this._waitRecords.get(row);
      if (record && this.waitRecordIsCurrent(record)) {
        record.batch = batch;
        if (record.state === "success" || record.state === "failed")
          this.advanceWaitBatch(row, batch);
        else if (record.state === "unconfirmed")
          this.resumeWaitDownload(this.currentIndex);
      } else this.startRowDownload(this.currentIndex, row.webType, batch);
    },
    advanceWaitBatch(row, batch) {
      if (
        !batch ||
        this._waitBatch !== batch ||
        row !== batch.rows[batch.index] ||
        batch.advanced.has(row)
      )
        return;
      batch.advanced.add(row);
      this.$EventBus.$emit("nextId", {
        owner: this._waitOwner,
        batchId: batch.id,
        row,
      });
    },
    startRowDownload(index, webType, batch) {
      const row = this.tableData[index];
      if (this._waitDisposed || !row || !row.type) return;
      const existing = this._waitRecords.get(row);
      if (existing && this.waitRecordIsCurrent(existing)) {
        // A format change or a second click cannot create a second paid task.
        // Only an explicit V4 choice after a confirmed original-channel failure is new.
        const unpaidRetry =
          existing.precheckFailed && !existing.purchaseStarted;
        if (
          !unpaidRetry &&
          (existing.params.webType === webType ||
            existing.state !== "failed" ||
            webType !== "shutterstock_V4")
        )
          return existing;
        this.cancelWaitRecord(existing);
      }
      const record = {
        row,
        params: {
          imageID: row.id,
          webType,
          format: row.value,
          isCos: row.isCos,
        },
        session: getToken(),
        epoch: this._waitEpoch,
        active: true,
        handle: null,
        batch: batch || null,
        purchaseStarted: false,
        initialDisabled: Boolean(row.disabled),
        initialVideoDisabled: Boolean(row.videoDisabled),
        initialVideoValue: row.videoValue,
        initialVideoLabel: row.videoLabel,
      };
      this._waitRecords.set(row, record);
      if (row.waitPurchaseStarted && row.waitSession === record.session &&
          row.waitParams && row.waitParams.webType === webType) {
        record.params = { ...row.waitParams };
        record.purchaseStarted = true;
        record.handle = this._waitFlow.resume(record.params, this.waitCallbacks(record));
        return record;
      }
      this.applyWaitState(record, { state: "submitting" });
      if (!row.submitTime) this.$set(row, "submitTime", this.nowStr());
      Promise.resolve()
        .then(() => {
          if (!this.waitRecordIsCurrent(record)) return;
          return hasBlance({
            imageIDs: record.params.imageID,
            webType: record.params.webType,
          });
        })
        .then((enough) => {
          if (!this.waitRecordIsCurrent(record)) return;
          if (!enough) {
            record.precheckFailed = true;
            this.applyWaitState(record, {
              state: "failed",
              message: "下载失败，余额不足",
            });
            if (record.batch && this._waitBatch === record.batch) {
              this._waitBatch = null;
            }
            if (!this._waitBatch) {
              this.$emit("onSureDown", true);
              this.$emit("onDownload", false);
            }
            return;
          }
          record.purchaseStarted = true;
          record.handle = this._waitFlow.start(
            record.params,
            this.waitCallbacks(record)
          );
          if (!this.waitRecordIsCurrent(record)) this.cancelWaitRecord(record);
        })
        .catch(() => {
          if (!this.waitRecordIsCurrent(record)) return;
          record.precheckFailed = true;
          this.applyWaitState(record, { state: "unconfirmed" });
          this.advanceWaitBatch(row, record.batch);
        });
      return record;
    },
    // 原渠道与用户主动选择的 V4 共用相同的单次提交控制。
    downloadOne(index) {
      const row = this.tableData[index];
      if (row) this.startRowDownload(index, row.webType);
    },
    downloadOneV4(index) {
      this.startRowDownload(index, "shutterstock_V4");
    },
    pauseSearchDownloads() {
      this.tableData.forEach(row => {
        if (["quoting", "confirming"].includes(row.fallbackState)) this.setFallbackState(row, "");
        if (row.fallbackState === "manualSubmitting") {
          this.setFallbackState(row, "manualUnknown");
          row.msg = "工单提交状态未确认，请查看人工下载记录，勿重复提交";
        }
      });
      this.cancelWaitDownloads();
    },
    restoreSearchDownloads() {
      this.tableData.forEach((row, index) => {
        if (row.waitPurchaseStarted && row.waitSession === getToken() && row.waitParams && !row.complete)
          this.startRowDownload(index, row.waitParams.webType);
      });
    },
    retryWaitPrecheck(index) {
      const record = this._waitRecords.get(this.tableData[index]);
      if (record && record.precheckFailed && !record.purchaseStarted)
        this.startRowDownload(index, record.params.webType);
    },
    resumeWaitDownload(index) {
      const row = this.tableData[index];
      const record = this._waitRecords.get(row);
      if (
        !record ||
        !this.waitRecordIsCurrent(record) ||
        !record.purchaseStarted
      )
        return;
      if (record.handle) record.handle.resume();
      else {
        record.handle = this._waitFlow.resume(
          record.params,
          this.waitCallbacks(record)
        );
        if (!this.waitRecordIsCurrent(record)) this.cancelWaitRecord(record);
      }
    },
    // Legacy internal entry retained as a read-only resume, never a purchase.
    checkStatus(checkdata, index) {
      this.resumeWaitDownload(index);
    },
    //全部下载
    allDownload() {
      this.popSuccess();
    },
    //批量下载
    batchDownload() {
      //去重复
      let newArr = [];
      for (let i = 0; i < this.urlArray.length; i++) {
        if (newArr.indexOf(this.urlArray[i]) === -1) {
          newArr.push(this.urlArray[i]);
        }
      }
      for (var g = 0; g < newArr.length; g++) {
        const url = newArr[g];
        window.open(url, "_blank");
      }
    },

    //批量下载
    batchDownload1() {
      //去重复
      let newArr = [];
      for (let i = 0; i < this.urlArray1.length; i++) {
        if (newArr.indexOf(this.urlArray1[i]) === -1) {
          newArr.push(this.urlArray1[i]);
        }
      }

      for (var g = 0; g < newArr.length; g++) {
        const url = newArr[g];
        window.open(url, "_blank");
      }
    },
    //批量下载
    batchDownload2() {
      //去重复
      let newArr = [];
      for (let i = 0; i < this.urlArray2.length; i++) {
        if (newArr.indexOf(this.urlArray2[i]) === -1) {
          newArr.push(this.urlArray2[i]);
        }
      }
      for (var g = 0; g < newArr.length; g++) {
        const url = newArr[g];
        window.open(url, "_blank");
      }
    },

    //批量下载
    batchDownload3() {
      //去重复
      let newArr = [];
      for (let i = 0; i < this.urlArray3.length; i++) {
        if (newArr.indexOf(this.urlArray3[i]) === -1) {
          newArr.push(this.urlArray3[i]);
        }
      }
      for (var g = 0; g < newArr.length; g++) {
        const url = newArr[g];
        window.open(url, "_blank");
      }
    },
    batchCopy(e) {
      //去重复
      let newArr = [];
      for (let i = 0; i < this.urlArray.length; i++) {
        if (newArr.indexOf(this.urlArray[i]) === -1) {
          newArr.push(this.urlArray[i]);
        }
      }
      var text = "";
      for (var g = 0; g < newArr.length; g++) {
        text += newArr[g].replace("https", "http") + "\n";
      }
      const clipboard = new Clipboard(e.target, { text: () => text });
      clipboard.on("success", (e) => {
        message.success({
          message: "复制成功",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        message.success({
          message: "复制失败，请重试",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.onClick(e);
    },
    batchCopy1(e) {
      //去重复
      let newArr = [];
      for (let i = 0; i < this.urlArray1.length; i++) {
        if (newArr.indexOf(this.urlArray1[i]) === -1) {
          newArr.push(this.urlArray1[i]);
        }
      }
      var text = "";
      for (var g = 0; g < newArr.length; g++) {
        text += newArr[g].replace("https", "http") + "\n";
      }
      const clipboard = new Clipboard(e.target, { text: () => text });
      clipboard.on("success", (e) => {
        message.success({
          message: "复制成功",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        message.success({
          message: "复制失败，请重试",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.onClick(e);
    },
    batchCopy2(e) {
      //去重复
      let newArr = [];
      for (let i = 0; i < this.urlArray2.length; i++) {
        if (newArr.indexOf(this.urlArray2[i]) === -1) {
          newArr.push(this.urlArray2[i]);
        }
      }
      var text = "";
      for (var g = 0; g < newArr.length; g++) {
        text += newArr[g].replace("https", "http") + "\n";
      }
      const clipboard = new Clipboard(e.target, { text: () => text });
      clipboard.on("success", (e) => {
        message.success({
          message: "复制成功",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        message.success({
          message: "复制失败，请重试",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.onClick(e);
    },
    batchCopy3(e) {
      //去重复
      let newArr = [];
      for (let i = 0; i < this.urlArray3.length; i++) {
        if (newArr.indexOf(this.urlArray3[i]) === -1) {
          newArr.push(this.urlArray3[i]);
        }
      }
      var text = "";
      for (var g = 0; g < newArr.length; g++) {
        text += newArr[g].replace("https", "http") + "\n";
      }
      const clipboard = new Clipboard(e.target, { text: () => text });
      clipboard.on("success", (e) => {
        message.success({
          message: "复制成功",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        message.success({
          message: "复制失败，请重试",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.onClick(e);
    },
    deleteRow(index, row) {
      const removed = row[index];
      const record = this._waitRecords.get(removed);
      if (record) this.cancelWaitRecord(record);
      row.splice(index, 1);
      this.advanceWaitBatch(removed, this._waitBatch);
    },
    changePrice(index, row, label, val) {
      row[index].videoLabel = label;
      row[index].videoValue = val;
      console.log(row[index].webType);
      if (row[index].webType.indexOf("vistockphoto") != -1) {
        switch (val) {
          case 0:
            row[index].webType = "vistockphoto";
            break;
          case 1:
            row[index].webType = "vistockphotofk";
            break;
        }
      } else {
        switch (val) {
          case 0:
            row[index].isChange = false;
            row[index].webType = "video";
            if (row[index].isBuy) {
              row[index].msg = "免费";
            } else {
              row[index].msg = "";
            }
            break;
          case 1:
            row[index].isChange = true;
            row[index].webType = "videofk";
            if (row[index].isBuy1) {
              row[index].msg = "免费";
            } else {
              row[index].msg = "";
            }
            break;
          case 2:
            row[index].isChange = false;
            row[index].webType = "videoyx";
            if (row[index].isBuy) {
              row[index].msg = "免费";
            } else {
              row[index].msg = "";
            }
            break;
          case 3:
            row[index].isChange = true;
            row[index].webType = "videoyxfk";
            if (row[index].isBuy1) {
              row[index].msg = "免费";
            } else {
              row[index].msg = "";
            }
            break;
        }
      }
      row[index].price = row[index].priceList[val].price;
    },
    changeV3() {
      this.$emit("chanegV3", 1);
    },
    handleImgPreview(row) {
      this.imgPreviewVisible = true;
      if (row.webType.indexOf("shutterstock") > -1) {
        this.currentImg =
          "https://img.aatuku.com/preview260/" + row.id + ".jpg";
        this.currentError = row.errorIcon;
      } else {
        this.currentImg = row.img;
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
/* 两态状态表 + 等待模式感知 样式 */
.table {
  ::v-deep .el-table__header-wrapper th {
    background-color: #f5f7fa;
    color: #333;
    font-weight: 600;
  }
}
.id-tag {
  display: inline-block;
  padding: 2px 10px;
  background: #f0f7ff;
  color: #0773fc;
  border-radius: 4px;
  font-size: 13px;
  font-family: monospace;
}
.wait-time {
  margin-top: 5px;
  font-size: 12px;
  color: #999;
  i {
    margin-right: 3px;
  }
}
.time {
  font-size: 13px;
  color: #666;
}
::v-deep .wait-alert .el-alert__title,
::v-deep .wait-alert .el-alert__description {
  color: #f56c6c;
}
//进度条
.processBar {
  width: 240px;
  height: 7px;
  border: 1px solid #0059ca;
  border-radius: 2px;
  animation: progress-bar-stripes 2s linear infinite;
  background-color: #0773fc;
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
  background-size: 20px 20px;
  transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  opacity: 1;
}
@-webkit-keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }
  to {
    background-position: 0 0;
  }
}

@keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }
  to {
    background-position: 0 0;
  }
}

.content {
  text-align: center;
}

.table {
  .el-table__body {
    img {
      margin-right: 10px;
      float: left;
      width: 60px;
      height: 60px;
      border-radius: 4px;
    }
    .fr {
      .code {
        margin-top: 5px;
        margin-bottom: 5px;
        font-size: 14px;
        color: #578ade;
        .label {
          font-size: 16px;
          color: #43424b;
        }
      }
      .size {
        padding-left: 10px;
        font-size: 10px !important;
      }
    }
    .el-button--mini.is-round {
      padding: 4px 10px;
      span {
        font-size: 10px;
      }
    }
    .price {
      .font-blue {
        color: #0773fc;
      }
      .font-red {
        color: #f56c6c;
      }
      .font-green {
        color: #67c23a;
      }
    }
  }
}
.btn {
  margin: 20px 0 100px;
  .el-button {
    margin-bottom: 20px;
    margin-left: 0;
    padding: 15px 20px;
    width: 100%;
    font-size: 16px;
    // color: #0773fc;
    // background: #fff;
    border-color: #0773fc;
    outline: none;
    i {
      font-size: 16px;
    }
  }
  .el-button--primary.is-plain:hover {
    background: #0773fc;
    border-color: #0773fc;
    color: #ffffff;
  }
  .el-button--success.is-plain:hover {
    background: #00cc66;
    border-color: #00cc66;
    color: #ffffff;
  }
  .el-button--info.is-plain:hover {
    background: #ff9900;
    border-color: #ff9900;
    color: #ffffff;
  }
  .el-button--danger.is-plain:hover {
    background: #ff3300;
    border-color: #ff3300;
    color: #ffffff;
  }
}

.btn2 {
  margin: 20px 0 100px;
  .el-button {
    margin-bottom: 20px;
    margin-left: 0;
    padding: 15px 20px;
    width: 49.5%;
    font-size: 16px;
    color: #0773fc;
    background: #fff;
    border-color: #0773fc;
    outline: none;
    i {
      font-size: 16px;
    }
  }
  .el-button--primary.is-plain:hover {
    background: #0773fc;
    border-color: #0773fc;
    color: #ffffff;
  }
  .el-button--success.is-plain:hover {
    background: #00cc66;
    border-color: #00cc66;
    color: #ffffff;
  }
  .el-button--info.is-plain:hover {
    background: #ff9900;
    border-color: #ff9900;
    color: #ffffff;
  }
  .el-button--danger.is-plain:hover {
    background: #ff3300;
    border-color: #ff3300;
    color: #ffffff;
  }
}

.el-pagination {
  margin: 20px 0 30px;
}
.this-page {
  padding: 30px;
  background-color: white;
}
</style>
